import React from "react";
import { CaregiverUploadController } from "./controller";
import { CaregiverUploadView } from "./view";
import { extraStyles, styles } from "./styles";

export class CaregiverUpload extends React.Component {
  static navigationOptions = {
    title: `myCareBase Caregiver Application Upload`
  };

  controller = new CaregiverUploadController(this.props);

  render() {
    return (
      <CaregiverUploadView
        {...this.props}
        styles={styles}
        extraStyles={extraStyles}
        controller={this.controller}
      />
    );
  }
}
